import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router, Routes, Route, Navigate, Outlet } from "react-router-dom"; // 1. AJOUT DE OUTLET
import reportWebVitals from './reportWebVitals';

import Login from './pages/Login';
import Header from "./components/Header";
import Home from './pages/Home';
import Informations from './pages/Informations';
import Inscriptions from './pages/Inscriptions';
import Membres from './pages/Membres';
import Calendrier from './pages/Calendrier';
import Documents from './pages/Documents';
import Photos from './pages/Photos';

import YearSection from './components/YearSection';

import Error from './components/Error';
import { Setup } from "./utils/setup";
import Footer from "./components/Footer";
import { ThemeContext } from "./utils/ThemeContext";
import './index.css';

const ProtectedRoute = ({ children }) => {
    const token = localStorage.getItem("token");
    if (!token) return <Navigate to="/login" replace />;
    return children;
};

// 2. NOUVEAU COMPOSANT : Il sert à afficher le Header automatiquement
const LayoutWithHeader = () => {
    return (
        <>
            <Header />
            <Outlet /> {/* C'est ici que s'afficheront Home, Membres, etc. */}
            <Footer />
        </>
    );
};

const App = () => {
    // Plus besoin de calculer isLoggedIn ici, le Router va gérer ça dynamiquement

    return (
        <React.StrictMode>
            <ThemeContext.Provider value="black">
                <Router>
                    <Setup />

                    {/* 3. On a retiré le {isLoggedIn && <Header />} d'ici */}

                    <Routes>
                        {/* Routes Publiques (pas de Header) */}
                        <Route path="/login" element={<Login />} />

                        {/* 4. Routes Protégées (AVEC Header grâce au Layout) */}
                        {/* On dit : Si la route est protégée, affiche le LayoutWithHeader */}
                        <Route element={<ProtectedRoute><LayoutWithHeader /></ProtectedRoute>}>
                            <Route path="/" element={<Home />} />
                            <Route path="/home" element={<Home />} />
                            <Route path="/informations" element={<Informations />} />
                            <Route path="/inscriptions" element={<Inscriptions />} />
                            <Route path="/membres" element={<Membres />} />
                            <Route path="/calendrier" element={<Calendrier />} />
                            <Route path="/documents" element={<Documents />} />
                            <Route path="/photos" element={<Photos />} />

                            <Route path="/year-section" element={<YearSection />} />
                        </Route>

                        {/* Page 404 */}
                        <Route path="*" element={<Error />} />
                    </Routes>
                </Router>
            </ThemeContext.Provider>
        </React.StrictMode>
    );
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
reportWebVitals();